module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break--Body-",
    attrs: {
      "id": "_idParaDest-4"
    }
  }, [_vm._v("Chapter Two")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Baghdad Falls")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("April 2003")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("It’s typically a three-hour drive from Tikrit to Fahdi’s family village. The night he fled the Island Palace he made it in an hour and a half. After dropping Saif at a friend’s house outside Tikrit, Fahdi floored the gas pedal all the way to Mosul. The entire drive, his gaze alternated between the rearview mirror and the road ahead of him; positive at any minute he’d be chased down by Iraqi police o")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("r the military coming to arrest him for deserting his post.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Reaching his grandfather’s house, he climbed out ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("of his car visibly trembling with fear. His mother rushed ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("out and embraced her eldest child, praising God that he’d ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("made it out of Tikrit unscathed.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Fahdi’s paranoia did not subside until they received ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("a phone call a few days later from friends still in Baghdad, ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("reporting American military tanks had infiltrated the city. ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Less than twenty-four hours later, it was officially ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("announced on TV that Saddam Hussein was no longer in ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("power.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“We were a little skeptical at first because the village is far from Baghdad and out of range of any ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Baghdad-based news channels. We were only able to get ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Kurdish news channels, who were itching for Saddam to go ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("down, so it was quite possible they had jumped the gun on ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("reporting his fall from power.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Fahdi didn’t completely believe Saddam was truly ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("gone until two days later when, with his own eyes, he")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(" witnessed American tanks rolling through downtown ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Mosul.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“The tanks were intimidating, to say the least. The American M1 Abrams tanks are about three times the size ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("of the Iraqi tanks I was used to seeing. They were like moving buildings.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The U.S. tanks in Mosul had come down from the ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("North via Kurdistan and the Kurdish militia, the Peshmerga, came with them. According to reports, the ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Iraqi military commander in charge of Mosul surrendered ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("the city to the U.S. without a fight. Many residents of ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Mosul were acquiescent to the U.S. military presence, but they viewed the Peshmerga as anything but liberators.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Within days of the Kurdish militia’s arrival, accounts of the Peshmerga looting banks, mosques, ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("universities, and private businesses across Mosul began to ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("emerge. Bands of Mosul residents appealed to the U.S. ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("forces to put an end to the looting or at least try to curb ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("the rampant pillaging, but the Americans were reluctant to interfere, so the initial acceptance the residents of Mosul had for U.S. troops began transforming into resentment.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Although the situation in Mosul was deteriorating, it was still far superior to conditions in Baghdad. A steady ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("flow of evacuees from the capital city continued to flow into Mosul, bringing stories of mass chaos, destruction, and carnage. The sudden fall of Saddam’s government created a massive power vacuum resulting in the city essentially imploding into complete anarchy. With no ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("police or security forces remaining to enforce any measure ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("of law, street gangs quickly formed and began roaming Baghdad, taking anything they could carry away and burning buildings in retreat.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("As more accounts of the utter mayhem in Baghdad ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("poured in, Fahdi was anxious to return as soon as possible ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("to make sure his family’s business was still standing.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Fahdi had only been ten years old when his father ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("passed away, but thankfully, he’d built a successful ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("veterinary supply business that supported the family after his death. The business imported and sold vaccinations, ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("antibiotics, supplements, vitamins, hormones, etc. for ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("livestock to farmers. He desperately wanted to safeguard his family’s livelihood. The business was the main source of income for his widowed mother and younger siblings.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Fahdi and one of his uncles, Marwan, who also ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("lived in Baghdad and had evacuated to the village, decided ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("to return together to check on their homes and businesses. The journey back south was a surreal ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("experience for both. Along the route, the shoulders of the ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("highway were littered with burned out Iraqi Army tanks ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("and random billows of smoke rose across the desert from ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("smoldering buildings, vehicles, and other structures. As ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("they approached the outskirts of Baghdad, the concentration of American troops (mostly Marines), ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Humvees, tanks, and other military vehicles grew steadily.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Their first stop was Fahdi’s family’s business. Much ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("to their relief, it was intact and relatively unscathed. From ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("there, the pair continued to Fahdi’s house. Aside from a few blown-out windows and a busted front door, the ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("house was fully intact as well. At first, he feared the house ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("had been looted, but nothing was missing. Neighbors later ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("confirmed the damage was the result of an American ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("airstrike that hit so close the residual concussion from the bombs damaged many of the houses in the area.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("As they finished evaluating the damage, the sun began to set. Without enough daylight left to make it to Marwan’s house and not wanting to be out and about in ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Baghdad after dark, they decided it best to bed down for the night and check on Marwan’s house in the morning.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("It was a long sleepless night of persistent gunfire ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("and bedlam. Fahdi recognized most of the shooting was coming from AK-47s, not M-16s, meaning mostly Iraqi-on-")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Iraqi gunfire with very little American involvement. The Americans hadn’t yet infiltrated the residential neighborhoods; their first mission being to capture and secure the main thoroughfares and strategic arteries of the city. This allowed gangs and pockets of resistance fighters to organize in the shadows of dark alleys and ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("peripheral neighborhoods. Although the U.S. forces had ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("almost everything under control on the surface, thugs ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("were already vandalizing homes and battling each other ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("for control of residential turf right under the Americans’ ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("noses.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Fahdi and Marwan had returned to the city ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("unarmed, fearing it could cause them serious headache if ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("they were stopped on the road by any U.S. patrols who ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("may want to search their vehicle. Nonetheless, after that chaotic first night in Baghdad, the first thing Fahdi and his uncle did at Marwan’s house the next morning was grab ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("the two AK rifles and several boxes of ammunition ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Marwan had stored in a closet. They were leery of driving ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("back across town with weapons, but Fahdi’s house seemed ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("to be in a calmer area of the city than his uncle’s, so they ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("decided to make it their main base. They broke the ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("weapons down into as many pieces as possible and hid the ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("various parts throughout the vehicle.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("They spent the next week holed-up there, only ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("leaving to buy food from small, nearby convenience-type stores that were still operating. Inflation in Baghdad grew ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("astronomically as banks continued to be looted and burned in droves across the city, and trade, commerce, ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("and the economy all ground to a dead halt. A single piece ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("of flatbread that cost the equivalent of less than a nickel ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("prior to the invasion now cost a dollar. Many began to fear the city may face dire food shortages before the situation ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("stabilized.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Fahdi’s family greatly longed to return home, but conditions in Northern Iraq")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("—")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("security and food wise")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("—")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("were still a lot more stable. He instructed them to remain ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("at the village for a little longer. Kurdistan conducted independent trade with Turkey across Iraq’s northern border, meaning Fahdi’s family could always cross into Kurdish territory to purchase provisions if food became ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("scarce.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Fortunately, Baghdad did not experience any ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("serious food shortages. Iraq’s borders opened wide up (a ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("little too wide in fact) within a couple of weeks of the invasion and imports of all kinds began flowing into the ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("country from Syria, Iran, Turkey, and Jordan. This helped counter the mass inflation and, although the average cost of goods did not fall to pre-war levels, prices came down enough to successfully stabilize Baghdad’s economy for ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("the time being.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("People who had fled Baghdad began returning ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("home, including Fahdi’s family. Security in the residential ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("areas of the city was practically non-existent. Many ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("communities began neighborhood watch-type groups to ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("patrol several square blocks of area and secure it from ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("roving bandits, insurgent groups, and street gangs.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Fahdi’s neighborhood was predominantly comprised of Sunni Muslims, many of whom had military, police, and various governmental backgrounds. There ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("were plenty of experienced individuals")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("—")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Fahdi included—")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("to help organize their local neighborhood watch group ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("and secure their area. Also, considering their former ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("occupations, all were now unequivocally unemployed.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Fahdi’s family were the only Christians on the street and the land their house sat on had been passed down to Fahdi’s father by his grandfather. The entire ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("region was a large plot of land the Ba’athists broke up and ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("gifted to retiring members of the government in the")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(" 1970s. Fahdi’s grandfather had worked his way up the ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("ladder to a senior level position within Baghdad’s Crime ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Scene Investigation agency. (For those of you familiar with ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("the popular TV series")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "ital CharOverride-2"
  }, [_vm._v("C.S.I")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("., he was the Iraqi version of ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Detective Gil Grissom.)")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Fahdi’s neighborhood watch group, which consisted of about twenty-five men, began securing the area by cordoning off a one-square kilometer section of ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("the neighborhood. Utilizing rocks, bricks, and debris, they ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("erected road blocks to prevent traffic via any peripheral ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("side streets, and established manned checkpoints at the ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("two main entryways into the neighborhood. They then ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("scheduled a rotating watch to ensure each checkpoint was ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("manned by at least two people at all times, while a third two-man team was constantly on patrol to maintain security of the perimeter. No one was allowed in the ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("neighborhood unless they were a resident or personally ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("escorted by a resident. Fahdi later compared it to how the ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("survivors in the hit AMC show")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "ital CharOverride-2"
  }, [_vm._v("The")]), _c('span', {
    staticClass: "ital CharOverride-2"
  }), _c('span', {
    staticClass: "ital CharOverride-2"
  }, [_vm._v("Walking")]), _c('span', {
    staticClass: "ital CharOverride-2"
  }), _c('span', {
    staticClass: "ital CharOverride-2"
  }, [_vm._v("Dead")]), _c('span', {
    staticClass: "ital CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("would ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("safeguard their settlements.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“It’s almost like whoever they have advising the ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("producers for the show on how to establish and maintain security for the neighborhoods must have had experience in Baghdad after the war, because that’s exactly how we ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("operated our security teams.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Fahdi and his neighbors were fortunate to get their ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("area secured in a timely manner as the city soon delved ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("into considerable sectarian strife. Shiite Muslim militias ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("banded together and began carrying out revenge killings ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("on Sunni Muslims who had enjoyed special privileges ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("under Saddam’s predominantly Sunni regime. With Iraq’s border security practically non-existent, Shiite mutineers ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("and radicals flowed in from neighboring Iran, inciting violence and swelling the ranks of the Shiite militias. Suddenly, all the old grudges built up between Iraq’s Sunnis and Iran’s Shiites during the eight-year Iran-Iraq ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("War of the 1980s were being settled right under the ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Americans’ noses. To counter the Shiite assaults from the ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("East, foreign Sunni extremists flowed into the country ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("from Syria and Jordan on the western side of the country. ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The two opposing Islamic factions met in the middle of ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Baghdad in a bloody sectarian brawl that continues more ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("than a dozen years later.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The Americans were caught off guard and found themselves in the middle of a secondary war they didn’t expect and were not prepared for. All the U.S. commanders on the ground understood at the time was ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("that Saddam and his cronies were Sunnis, and since the ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Shiites were enemies of the Sunnis, they must be good. ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Unfortunately, the enemy of your enemy isn’t always your ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("friend. The Shiite militias were heavily influenced and supported by the Iranian government who")]), _c('span', {
    staticClass: "CharOverride-2"
  }), _c('span', {
    staticClass: "ital CharOverride-2"
  }, [_vm._v("did")]), _c('span', {
    staticClass: "ital CharOverride-2"
  }), _c('span', {
    staticClass: "ital CharOverride-2"
  }, [_vm._v("not")]), _c('span', {
    staticClass: "ital CharOverride-2"
  }), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("have ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("the American’s best interests at heart in any way, shape, or form. Essentially, all the U.S. had managed to do was ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("wrest Iraq from the grip of one totalitarian regime and deposit it into the palm of another.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77df12b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VoicingtheEagle26.vue
// module id = 75
// module chunks = 0